export default __webpack_public_path__ + "static/media/Yoast_SEO_for_WP_2.ee13e34d.svg";